import React from "react";
import { Registration } from "../components/Registration";

const Contact = () => (
    <Registration full={true} />
);

export default Contact;
